import { useCallback } from 'react';

import { fetchVersionsAction } from '../apiActions/fetchVersionsAction';
import { useCoreDispatch } from '../CoreStore';
import { useConfigSlice } from '../slices/config/selectors';

export const useVersionsFetcher = (essential: boolean): (() => void) => {
  const dispatch = useCoreDispatch();
  const baseUrl = useConfigSlice.baseUrl();
  const gameType = useConfigSlice.getGameType()?.toLowerCase();
  const tableVariant = useConfigSlice.getTableVariant()?.toLowerCase();
  const game = tableVariant || gameType;
  const JSESSIONID = useConfigSlice.JSESSIONID();

  return useCallback(() => {
    if (baseUrl && game && JSESSIONID) {
      dispatch(
        fetchVersionsAction({
          url: baseUrl + '/api/ge/versions',
          // todo: Endpoint returns same data without game and JSESSIONID params. Think if really required here.
          game,
          JSESSIONID,
          essential,
        })
      );
    }
  }, [JSESSIONID, game, baseUrl, dispatch, essential]);
};
